export default __webpack_public_path__ + "static/media/nfl.b2bbbd23.png";